module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(10).2336b89c.png";